





























































/* eslint-disable max-len */

import Page from '@/components/layouts/Page.vue'
import PageSection from '@/components/layouts/PageSection.vue'
import EditableTabularList from '@/components/appBase/forms/EditableTabularList.vue'
import ApiError from '@/components/appBase/errors/ApiError.vue'
import DelayedDisplay from '@/components/appBase/DelayedDisplay.vue'
import useApiErrorViewHandler from '@/components/appBase/errors/useApiErrorViewHandler'
import useClientflowApi from '@/api/clientFlow/useClientflowApi'

import {
  defineComponent, reactive, toRefs, computed, onBeforeMount,
} from '@vue/composition-api'

const initialState: {
  showDeleteClientModal: boolean;
  loading: boolean;
} = {
  showDeleteClientModal: false,
  loading: false,
}

/**
 * Define the fixed properties of participant fields.
 * These will get matched up with what comes from vuex
 * this is kind of ad-hoc,
  */
const participantFields = {
  attachedById: {
    type: 'text',
  },
  id: {
    type: 'text',
  },
  attachedDate: {
    type: 'isoDate',
  },
  consent: {
    type: 'text',
  },
  consentGivenAt: {
    type: 'isoDate',
  },
  adminNote: {
    type: 'editor',
  },
  dbUpdatedAt: {
    type: 'isoDate',
    editable: false,
  },
  dbCreatedAt: {
    type: 'isoDate',
    editable: false,
  },
}

const ClientPage = defineComponent({
  components: {
    // eslint-disable-next-line vue/no-unused-components
    Page, PageSection, EditableTabularList, DelayedDisplay, ApiError,
  },
  props: {
    studyId: {
      type: String,
      default: '',
    },
    caseId: {
      type: String,
      default: '',
    },
  },

  setup(props, context) {
    const state = reactive({ ...initialState })

    /** reactive get cases from store */
    const studyCase = computed(() => context.root.$store.getters['studyCases/getById'](props.caseId))

    const studyCaseFields = computed(() => {
      if (studyCase.value === undefined) return undefined

      const fields: { [key: string]: unknown } = {}

      // eslint-disable-next-line no-restricted-syntax
      for (const [key, definition] of Object.entries(participantFields)) {
        const value = studyCase.value[key] !== undefined ? studyCase.value[key] : null

        fields[key] = {
          name: key,
          type: definition.type,
          editable: (definition as unknown as {editable: boolean}).editable !== undefined ? (definition as unknown as {editable: boolean}).editable : true,
          value,
          label: key,
        }
      }

      return fields
    })

    const getPageTitle = computed(() => {
      const title = studyCase.value === undefined ? '' : (studyCase.value as {id: string}).id
      return title
    })

    // Compose!
    // ...delegate api handling to useClientflowApi():
    const {
      ClientFlowApi,
      awaitingResponse,
      hasResponseError,
      handler,
      reset,
      errorDisplay,
    } = useClientflowApi()

    // ...delegate logic around showing api error to useApiErrorViewHandler():
    const {
      errorVisibilityHasChangedTo,
      toggleShowApiError,
      showResponseError,
      showingResponseError,
    } = useApiErrorViewHandler(hasResponseError)

    /**
     * The function that calls the api
     */
    async function updateParticipantInfo(studyId: string, participantId: string, data: { [key: string]: unknown }) {
      // console.log('updating')
      // @ts-ignore sorry! I have skipped type safety here TODO: implement type safety
      const cmd = await ClientFlowApi.updateParticipantInfo({ ...data, studyId, participantId })
      const response = await handler.handle(cmd)
      if (response.isOk()) {
        // state.isInEditMode = false
      }
    }

    /**
     * The update function that is exposed to the template
     */
    async function onUpdateParticipantFields(data: { [key: string]: unknown }) {
      await updateParticipantInfo(props.studyId, props.caseId, data)
    }

    /**
     * Resets the state of the api handler (e.g. removes error state, etc)
     */
    function onFormClosed() {
      reset()
    }

    onBeforeMount(() => {
      try {
        if (context.root.$store.getters['studyCases/getById'](props.caseId) === undefined) {
          // console.log('findes ikke', props.caseId)
          state.loading = true
          // https://stackoverflow.com/questions/47876754/query-firestore-database-for-document-id
          context.root.$store.dispatch('studyCases/openDBChannel', {
            pathVariables: { studyId: props.studyId },
            where: [['__name__', '==', props.caseId]],
          })
            .then(() => {
              state.loading = false
              // console.log('we got data')
            })
        } else {
          state.loading = false
          // console.log('we already had the data')
        }
        // setFieldsToUpdateOnRemoteChange(true)
      } catch (e) {
        state.loading = false
        // console.log('some error')
        // console.log(e)
        // TODO:  check the error. It might just be that the dbchanell is already open
      }
    })

    return {
      ...toRefs(state),
      studyCase,
      studyCaseFields,
      onUpdateParticipantFields,
      onFormClosed,
      getPageTitle,

      // from use ClienFlowApi
      hasResponseError,
      awaitingResponse,
      errorDisplay,

      // from useApiErrorViewHandler
      showingResponseError,
      showResponseError,
      toggleShowApiError,
      errorVisibilityHasChangedTo,
    }
  },
})

export default ClientPage

